<template>
<nav aria-label="Page navigation example">
<!-- {{noofpages}},{{page}},{{noperpage}},{{showrecordscount}},,{{maxofrecords}} -->
  <ul class="pagination justify-content-center">
    <template v-if="page == 0">
      <li class="page-item disabled"><a href="#"  class="page-link" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
    </template>
    <template v-if="page != 0">
      <li class="page-item"><a href="#"  class="page-link" aria-label="Previous" v-on:click.stop.prevent="goto(page -1)" :pageno="page -1"  aria-hidden="true">&laquo;</a></li>
    </template>   
    <template v-for="(_page, index) in noofpages">
      <template v-if="_page == page"><li :key="index" class="page-item active"><a href="#"  class="page-link">{{showrecordscount?((_page*noperpage+1)+" - "+ Math.min(((_page+1)*noperpage),maxofrecords) ):_page + 1}} <span class="sr-only">(current)</span></a></li></template>
      <template v-if="_page != page"><li :key="index" class="page-item"><a  class="page-link" href="#" v-on:click.stop.prevent="goto(_page)" :pageno="_page" >{{showrecordscount?((_page*noperpage+1)+" - "+Math.min(((_page+1)*noperpage),maxofrecords) ):_page + 1}}</a></li></template>
    </template>
    <template v-if="page == noofpages[noofpages.length -1]">
      <li class="page-item disabled"><a  class="page-link" href="#" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>
    </template>
    <template v-if="page != noofpages[noofpages.length -1]">
      <li class="page-item"><a  class="page-link" href="#" aria-label="Next" v-on:click.stop.prevent="goto(page +1)" :pageno="page +1"  aria-hidden="true">&raquo;</a></li>
    </template>
  </ul>
</nav>
</template>

<script>
module.exports = {

  props: ['noofpages','page','noperpage','showrecordscount','maxofrecords'], 

  methods:{
    goto: function(event){
      // console.log(event)
      // pages.page= parseInt($(event.target).attr("pageno"));
      this.$emit('goto',event);
    }
  }
}
</script>
<style scoped>
ul {
  color: #000022;
  list-style:none !important;
  padding-left: 0px;
}
</style>